/**
 * @generated SignedSource<<946241e47bc89e409f19167c8e76e7c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "direction"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "routeId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "time"
},
v4 = [
  {
    "kind": "Variable",
    "name": "date",
    "variableName": "date"
  },
  {
    "kind": "Variable",
    "name": "direction",
    "variableName": "direction"
  },
  {
    "kind": "Variable",
    "name": "route",
    "variableName": "routeId"
  },
  {
    "kind": "Variable",
    "name": "time",
    "variableName": "time"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gtfsId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectVehicleContainerFuzzyQuery",
    "selections": [
      {
        "alias": "trip",
        "args": (v4/*: any*/),
        "concreteType": "Trip",
        "kind": "LinkedField",
        "name": "fuzzyTrip",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TripMarkerPopup_trip"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SelectVehicleContainerFuzzyQuery",
    "selections": [
      {
        "alias": "trip",
        "args": (v4/*: any*/),
        "concreteType": "Trip",
        "kind": "LinkedField",
        "name": "fuzzyTrip",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Pattern",
            "kind": "LinkedField",
            "name": "pattern",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headsign",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Stop",
                "kind": "LinkedField",
                "name": "stops",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Route",
            "kind": "LinkedField",
            "name": "route",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shortName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f05129786fd5e5aaebe2f604c0eb0015",
    "id": null,
    "metadata": {},
    "name": "SelectVehicleContainerFuzzyQuery",
    "operationKind": "query",
    "text": "query SelectVehicleContainerFuzzyQuery(\n  $routeId: String!\n  $direction: Int!\n  $time: Int!\n  $date: String!\n) {\n  trip: fuzzyTrip(route: $routeId, direction: $direction, time: $time, date: $date) {\n    ...TripMarkerPopup_trip\n    id\n  }\n}\n\nfragment TripMarkerPopup_trip on Trip {\n  gtfsId\n  pattern {\n    code\n    headsign\n    stops {\n      name\n      id\n    }\n    id\n  }\n  route {\n    gtfsId\n    mode\n    shortName\n    color\n    type\n    id\n  }\n}\n"
  }
};
})();

node.hash = "57d5ef4f71dbafffdb8487de8d60217c";

module.exports = node;
